import React, { useEffect, useState, useRef } from "react"
import { Link, router, usePage } from "@inertiajs/react"
import organizeMenusIntoHierarchy from "@/utils/organizeMenusIntoHierarchy"
import MenuItem from "@/Admin/Components/Header/MenuItem"
import { useSelector } from "react-redux"
import translate from "@/utils/translate"
import SideHeader from "./SideHeader"
import GlobalSearch from "./GlobalSearch"
import LanguageDropdown from "./LanguageDropdown"
import gravatarUrl from "gravatar-url"
import useConfirmation from '@/Admin/Components/ActionConfirmation/useConfirmation';
import ConfirmationModal from '@/Admin/Components/ActionConfirmation/ConfirmationModal';

export default function Header4() {
    const { cart_slug } = usePage().props
    const { carts } = useSelector((state) => state.carts)
    const { currentLang, pageInfo } = useSelector((state) => state.pages)
    const currentLangPageInfo = pageInfo[currentLang]
    const customize = useSelector((state) => state.customize)
    const [sideHeaderToggle, setSideHeaderToggle] = useState(false)
    const [mobileToggle, setMobileToggle] = useState(false)
    const [isSticky, setIsSticky] = useState()
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false)
    const { lang, auth } = usePage().props
    const currentLanguage = currentLang ?? lang.default_lang
    const mainMenus = localStorage.getItem("main_menu") ? JSON.parse(localStorage.getItem("main_menu")) : []
    const menus = mainMenus ? organizeMenusIntoHierarchy(mainMenus[currentLanguage]) : []

    const confirmLogout = useConfirmation();

    const cartItemCount = carts?.reduce((total, item) => total + (item.quantity ?? 1), 0) ?? 0

    const handleProfileDropdownToggle = () => setProfileDropdownOpen(!profileDropdownOpen)

    // handle logout
    const handleLogout = () => {
        confirmLogout.showConfirmation({
            title: `${translate("Are you sure")}`,
            message: `${translate("logout_session")}`,
            confirmText: `${translate("log_out")}!`,
            cancelText: translate("Cancel"),
            onConfirm: () => {
                router.post(route("logout"))
            },
            onCancel: () => {},
            onClose: () => {},
        });
    }

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                setIsSticky(true)
            } else {
                setIsSticky(false)
            }
        })
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".cs_dropdown_wrap")) {
                setProfileDropdownOpen(false)
            }
        }

        if (profileDropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }

        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [profileDropdownOpen])

    return (
        <>
            <header
                id="top" className={`cs_site_header cs_style_1 cs_color_1 cs_primary_bg cs_sticky_header cs_size_md${isSticky ? " cs_sticky_active" : ""}`}
            >
                <div className="cs_top_header cs_accent_bg">
                    <div className="container">
                        <div className="cs_top_header_in">
                            <div className="cs_top_header_left">
                                <ul className="cs_header_contact_list cs_mp0">
                                    {customize?.contact?.contact_email && (
                                        <li>
                                            <i>
                                                <i className="fa-light fa-envelope" style={{ fontSize: '18px' }}></i>
                                            </i>
                                            <a href={`mailto:${translate(customize?.contact?.contact_email)}`}>
                                                {translate(customize?.contact?.contact_email)}
                                            </a>
                                        </li>
                                    )}
                                    {customize?.contact?.contact_phone_number && (
                                        <li>
                                            <i>
                                                <i className="fa-light fa-phone" style={{ fontSize: '16px' }}></i>
                                            </i>
                                            <a href={`tel:${translate(customize?.contact?.contact_phone_number)}`}>
                                                {translate(customize?.contact?.contact_phone_number)}
                                            </a>
                                        </li>
                                    )}
                                    {customize?.contact?.contact_address && (
                                        <li>
                                            <i>
                                                <i className="fa-light fa-location-dot" style={{ fontSize: '18px' }}></i>
                                            </i>
                                            <p
                                                className="mb-0"
                                                dangerouslySetInnerHTML={{
                                                    __html: translate(customize?.contact?.contact_address) ?? ""
                                                }}
                                            />
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="cs_top_header_right">
                                <div className="cs_header_social">
                                    {customize?.social_links?.social_list?.map((item, index) => (
                                        <a href={item?.social_url ?? "#"} target="_blank" key={index}>
                                            {item?.social_title ?? ""}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cs_main_header">
                    <div className="container">
                        <div className="cs_main_header_in">
                            <div className="cs_main_header_left">
                                <Link className="cs_site_branding" to="/" href="/">
                                    <img src={customize?.general?.site_logo_light ?? ""} alt={customize?.general?.site_name ?? ""} />
                                </Link>
                            </div>
                            <div className="cs_main_header_center">
                                <div className="cs_nav">
                                    <nav className={`cs_nav_list_wrap${mobileToggle ? " cs_active" : ""}`}>
                                        <ul className="cs_nav_list">
                                            {menus?.map((menuItem) => (
                                                <MenuItem setMobileToggle={setMobileToggle} key={menuItem.id} item={menuItem} />
                                            ))}
                                        </ul>
                                    </nav>
                                    <span
                                        className={`cs_menu_toggle${mobileToggle ? " cs_toggle_active" : ""}`}
                                        onClick={() => setMobileToggle(!mobileToggle)}
                                    >
                                        <span></span>
                                    </span>
                                </div>
                            </div>
                            <div className="cs_main_header_right">
                                <div className="cs_toolbox">
                                    <GlobalSearch />
                                    {auth?.is_loggedIn ? (
                                        <div className="cs_dropdown_wrap">
                                            <div
                                                onClick={handleProfileDropdownToggle}
                                                className={`cs_header_user_btn ${profileDropdownOpen ? "active" : ""}`}
                                            >
                                                <i className="fa-light fa-circle-user" style={{ fontSize: '20px' }}></i>
                                            </div>
                                            {profileDropdownOpen && (
                                                <div className="cs_header_user_dropdown">
                                                    <div className="cs_header_user_info">
                                                        <img src={gravatarUrl(auth?.user?.email) ?? ""} alt="" />
                                                        <h4 className="">{auth?.user?.name}</h4>
                                                        <p className="">{auth?.user?.email}</p>
                                                    </div>
                                                    <ul className="cs_header_user_list cs_mp0">
                                                        <li>
                                                            <Link href={route("user.dashboard")}>{translate("Dashboard")}</Link>
                                                        </li>
                                                        <li>
                                                            <Link href={route("user.orders")}>{translate("My Orders")}</Link>
                                                        </li>
                                                        <li>
                                                            <Link href={route("user.profile.edit")}>{translate("Profile")}</Link>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                                                                {translate("log_out")}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="cs_header_user_btn active d-flex">
                                            <Link href={route("login.create")}>{translate("Login")}</Link>
                                        </div>
                                    )}
                                    {currentLangPageInfo?.is_show_shopping_cart && (
                                        <Link href={route("pages.show", { slug: cart_slug })} className="cart-counter">
                                            <i className="fa-sharp fa-light fa-cart-arrow-down fs-4"></i>
                                            {cartItemCount === 0 ? "" : <span>{cartItemCount}</span>}
                                        </Link>
                                    )}
                                    {Object.entries(lang.languages).length > 1 && <LanguageDropdown />}
                                    <button
                                        className="cs_hamburger_btn cs_hamburger_info_btn "
                                        onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                                    >
                                        <i className="fa-regular fa-bars-staggered fs-4"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <SideHeader sideHeaderToggle={sideHeaderToggle} setSideHeaderToggle={setSideHeaderToggle} customize={customize} />

            <ConfirmationModal
                isOpen={confirmLogout.isOpen}
                title={confirmLogout.title}
                message={confirmLogout.message}
                confirmText={confirmLogout.confirmText}
                cancelText={confirmLogout.cancelText}
                onConfirm={confirmLogout.handleConfirm}
                onCancel={confirmLogout.handleCancel}
                onClose={confirmLogout.handleClose}
            />
        </>
    )
}